import React, { FC, useEffect, useState } from "react";
import { Media } from "@/services/bedrock";
import ReactPlayer from "react-player";
import { Image } from "semantic-ui-react";

interface Props {
  media: Media;
  previewOnly?: boolean;
  autoPlay?: boolean;
  playbackRate?: number;
}

export const MediaPlayer: FC<Props> = ({ media, previewOnly = false, autoPlay = false, playbackRate = 1 }) => {
  const [playWhenReady, setPlayWhenReady] = useState(autoPlay);
  const [mediaPlaying, setMediaPlaying] = useState(autoPlay);
  const [mediaReady, setMediaReady] = useState(false);

  useEffect(() => {
    if (autoPlay) {
      setPlayWhenReady(true);
      setMediaPlaying(true);
    }
  }, [autoPlay]);

  useEffect(() => {
    if (playWhenReady && mediaReady) {
      setMediaPlaying(true);
    }
  }, [playWhenReady, mediaReady]);

  const renderThumbnail = () => {
    if (media?.thumbnailUri) {
      return <Image src={media.thumbnailUri} className="mediaThumbnail" />;
    }

    if (media?.category === "VIDEO" && media?.uri) {
      return (
        <video
          src={`${media.uri}#t=0.001`}
          preload="metadata"
          className="mediaThumbnail"
          style={{ width: "100%", height: "auto", display: "block" }}
          muted
          playsInline
        />
      );
    }

    return null;
  };

  return (
    <div className="mediaContainer">
      {media?.category === "VIDEO" && !previewOnly && (
        <ReactPlayer
          url={media?.uri}
          light={autoPlay ? false : renderThumbnail() ?? true}
          width="100%"
          height="auto"
          controls
          playsinline
          playing={mediaPlaying}
          playbackRate={playbackRate}
          onClickPreview={() => setPlayWhenReady(true)}
          onReady={() => setMediaReady(true)}
          onPause={() => setMediaPlaying(false)}
        />
      )}

      {media?.category === "VIDEO" && previewOnly && renderThumbnail()}

      {media?.category === "IMAGE" && <Image src={media?.thumbnailUri || media?.uri} className="mediaThumbnail" />}
    </div>
  );
};
